import { useModal } from '@shared/model/useModal';

export const usePackagesModal = () => useModal('packages')
